/**
 * Freezes the page behind modal overlays. A native modal `<dialog>` makes the
 * page inert but still lets it scroll, and iOS Safari ignores
 * `overflow: hidden` on `body`. So the body is pinned with `position: fixed`
 * at the current offset and the offset is restored on release (#153).
 *
 * Overlays stack (dialog, then confirmation): a counter releases the page only
 * when the last one is gone. `scrollbar-gutter: stable` (base.css, keyed on
 * `data-scroll-locked`) keeps the layout from jumping on desktop.
 *
 * The shifted `body` drags `sticky` descendants along, so persistent chrome
 * (the desktop sidebar) is `position: fixed` instead (#171).
 */
let locks = 0;
let savedY = 0;

export function lockScroll() {
  if (locks++ > 0) return;
  const { documentElement: root, body } = document;
  savedY = window.scrollY;
  root.dataset.scrollLocked = '';
  body.style.position = 'fixed';
  body.style.top = `${-savedY}px`;
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
}

export function unlockScroll() {
  if (locks === 0 || --locks > 0) return;
  const { documentElement: root, body } = document;
  delete root.dataset.scrollLocked;
  // Release and restore in one frame, without smooth scrolling (#162).
  const behavior = root.style.scrollBehavior;
  root.style.scrollBehavior = 'auto';
  for (const property of ['position', 'top', 'left', 'right', 'width']) {
    body.style.removeProperty(property);
  }
  window.scrollTo(0, savedY);
  root.style.scrollBehavior = behavior;
}
